import { hasPermission } from "../../Config/permissions.js";

const AS_USER_TYPES = new Set(["Admin", "ASD", "Authorizer", "Viewer"]);

export const canEditDistributorCommissionContract = (user) =>
  Boolean(
    user &&
      AS_USER_TYPES.has(user.Type) &&
      hasPermission(user, "dist_contract.edit"),
  );

export const canDeleteDistributorCommissionContract = (user) =>
  canEditDistributorCommissionContract(user);

export const canDuplicateDistributorCommissionContract = (user) =>
  canEditDistributorCommissionContract(user);

export const canAccessDistributorCommissionContract = (
  user,
  contractId,
) => {
  if (!user) return false;

  if (user.Type === "Distributor") {
    return Boolean(contractId) && hasPermission(user, "dist_contract.view");
  }

  if (!AS_USER_TYPES.has(user.Type)) return false;

  return contractId
    ? hasPermission(user, "dist_contract.view")
    : canEditDistributorCommissionContract(user);
};
